module.exports = __webpack_public_path__ + "img/btn2.7009fc78.png";